import type { TenantBranding } from "../types";
import { PageHeader } from "../components/Chrome";

// A7 — Branding. v1 is READ-ONLY: branding lives in TenantSpec which is
// owned by the reconciler. The screen shows the current values + tells
// the operator to update via the spec workflow. Live brand-color editing
// will come once TenantSpec edits flow through the admin API.
export function AdminBranding({ branding }: { branding: TenantBranding }) {
  return (
    <div className="container">
      <PageHeader title="Branding" />
      <p style={{ color: "var(--ink-3)" }}>
        Branding is sourced from your TenantSpec. v1 is read-only here;
        update the spec and rerun the reconciler to change branding.
      </p>
      <div className="meta-grid">
        <div>
          <span className="meta-label">Display name</span>
          <span>{branding.display_name}</span>
        </div>
        <div>
          <span className="meta-label">Application name</span>
          <span>{branding.application_name}</span>
        </div>
        <div>
          <span className="meta-label">Primary color</span>
          <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span
              style={{
                display: "inline-block",
                width: 18,
                height: 18,
                borderRadius: 4,
                background: branding.primary_color,
                border: "1px solid var(--hair)",
              }}
            />
            <code>{branding.primary_color}</code>
          </span>
        </div>
        {branding.secondary_color && (
          <div>
            <span className="meta-label">Secondary color</span>
            <code>{branding.secondary_color}</code>
          </div>
        )}
        {branding.logo_url && (
          <div>
            <span className="meta-label">Logo</span>
            <img
              src={branding.logo_url}
              alt=""
              style={{ maxHeight: 48 }}
            />
          </div>
        )}
        {branding.domain && (
          <div>
            <span className="meta-label">Domain</span>
            <span>{branding.domain}</span>
          </div>
        )}
      </div>
    </div>
  );
}
